import React, { useState, useEffect, useRef } from "react";
import SwiperCore, { Navigation, Lazy, Thumbs } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
SwiperCore.use([Navigation, Lazy, Thumbs]);

// gallery
type GalleryProps = {
	images: {
		[key: string]: any;
	}[];
	postId: string;
};
const Gallery: React.FC<GalleryProps> = (props) => {
	const { images, postId } = props;
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	return (
		<div className="c-swiper-gallery">
			<div className="c-swiper-gallery-main">
				<Swiper
					thumbs={{ swiper: thumbsSwiper }}
					navigation={images.length > 1 ? true : false}
					lazy={true}
					autoHeight={true}
					// onSwiper={(swiper) => console.log(swiper)}
					// onSlideChange={(params) =>
					// 	console.log("slide change", params.activeIndex)
					// }
					className={`swiper-main-${postId}`}
				>
					{images.map((image) => {
						const { id, alt, sizes } = image;
						return (
							<SwiperSlide key={id}>
								<img
									src={sizes.medium}
									alt={alt}
									width={sizes["medium-width"]}
									height={sizes["medium-height"]}
									className="c-swiper-gallery-main__img"
								/>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
			<div className="c-swiper-gallery-thumbnail">
				<Swiper
					onSwiper={setThumbsSwiper}
					spaceBetween={6}
					slidesPerView={5}
					resistanceRatio={0}
					className={`swiper-thumbnail-${postId}`}
				>
					{images.map((image) => {
						const { id, alt, sizes } = image;
						return (
							<SwiperSlide key={id}>
								<img
									src={sizes.thumbnail}
									alt={alt}
									width={sizes["thumbnail-width"]}
									height={sizes["thumbnail-height"]}
									className="c-swiper-gallery-thumbnail__img"
								/>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
};

export default Gallery;
